export class PhysicsSettings {
    constructor() {
        this.flags = 0;
        this.maxSubSteps = 1;
        this.fixedTimeStep = 1.0 / 60.0;
        this.enableCCD = false;
        this.ccdThreshold = 0.0001;
        this.ccdSphereRadius = 0.0001;
    }
}
